export const BANNER_ACTION_TYPES = {
    EXTERNAL_URL: 'external_url',
    INTERNAL_URL: 'internal_url',
} as const;

export const BANNER_LOCATIONS = {
    DESKTOP_ORDER_FORM: 'desktop_order_form',
    MOBILE_PROFILE: 'mobile_profile',
    PORTFOLIO: 'portfolio',
} as const;

export const BANNER_BEHAVIORS_AFTER_CLOSE = {
    OPEN_NEXT_DAY: 'open_next_day',
    OPEN_NEXT_SESSION: 'open_next_session',
} as const;

export const BANNER_DEPENDS_ON_PARAMS = {
    AB_TEST: 'ab_test',
    BONUS: 'bonus',
    FEATURE: 'feature',
    PROMOCODE: 'promocode',
} as const;

export const BANNER_DEPENDS_ON_BONUS_STATES = {
    ACTIVE: 'active',
    AVAILABLE: 'available',
    ACTIVE_OR_AVAILABLE: 'active_or_available',
} as const;

export const BANNER_DEPENDS_ON_PROMOCODE_STATES = {
    ACTIVE: 'active',
} as const;

export const BANNER_DEPENDS_ON_AB_TEST_STATES = {
    SHOW: 'show',
    HIDE: 'hide',
} as const;
